<style type="text/css" lang="scss">
    @import '../../../static/css/reset.scss';

    #headerBig {
    	width:100%;
    	height: 70px;
    	background-color: #364983;
        #headerSma{
            position:relative;
            width:1120px;
            height:100%;
            margin:0 auto;
            .content{
                width: 910px;
                float: left;
                padding-right: 4px;
                .logo{
                    display:inline-block;
                    width:279px;
                    height:32px;
                    margin-top:18px;
                    float:left;
                    cursor:pointer;
                }
                .navs{
                    float: right;
                    margin-right: 15px;
                    .navSpan{
                        display:inline-block;
                        height:100%;
                        position: relative;
                        padding:0 11px;
                        padding-top: 32px;
                        a{
                            position: relative;
                            display:inline-block;
                            font-size:16px;
                            width: 55px;
                            height: 38px;
                            text-align:center;
                            color:rgba(255,255,255,0.60);
                            letter-spacing: 0.12px;
                        }
                        &:hover{
                            a {
                                color: #fff;
                                &:after{
                                    position: absolute;
                                    content: '';
                                    left: 0px;
                                    right: 0px;
                                    bottom: 0px;
                                    border-bottom: 3px solid #fff;

                                }
                            }

                        }
                        &.current{
                            a {
                                color: #fff;
                                &:after{
                                    position: absolute;
                                    content: '';
                                    left: 0px;
                                    right: 0px;
                                    bottom: 0px;
                                    border-bottom: 3px solid #fff;

                                }
                            }
                        }
                    }
                }
            }
            .search-box {
                position: absolute;
                top: 75px;
                right: 0px;                  
                width: 470px;
                height: 50px;
                padding: 16px 30px;
                background: #EDEDED;
                box-shadow: 0 1px 3px 0 rgba(0,0,0,0.35);
                border-radius: 5px;
                z-index: 99;

                .search-inp {
                    float: left;
                    width: 340px;
                    height: 100%;
                    border-right: 1px solid #999;                       
                }
                .search-btn {
                    float: left;
                    width: 69px;
                    padding-left: 30px;
                    font-size: 14px;
                    color: #BC9B64;
                    cursor: pointer;
                    background: url("./images/search2.png") no-repeat 9px center;
                    background-size: 18px 17px;
                }
                .disabled {
                    color: #ccc;
                }
                .search-inp::-webkit-input-placeholder {
                    color: #999;
                }
                .search-inp::-moz-placeholder {
                    color: #999;
                }
                .search-inp:-moz-placeholder {
                    color: #999;
                }
                .search-inp:-ms-placeholder {
                    color: #999;
                }
            }
            .userBox{
                display:inline-block;
                float:right;
                // float: left;
                padding-top:27px;
                position: relative;
                width: 210px;
                height: 100%;
                &:before{
                    position: absolute;
                    content: '';
                    top: 0px;
                    bottom: 0px;
                    left: 0px;
                    border-left: 2px solid rgba(255,255,255,0.16);
                }
                &.isLogin{
                    height: 100%;
                    margin-top: 0px;
                    padding-top: 0px;
                    .search-icon-login {
                        float: left;
                        width: 28px;
                        height: 29px;
                        margin: 26px 18px 0px;
                        background-image: url('./images/search.png');
                        background-size: cover;
                        cursor:pointer;
                    }
                    .name{
                        cursor: pointer;
                        width:auto;
                        display: block;
                        float: left;
                        text-align: left;
                        max-width:74px;
                        overflow:hidden;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        font-size: 16px;
                        color: rgba(255,255,255,0.90);
                        height:auto;
                        line-height: 83px;
                        margin-right:4px;
                    }
                    .un-toggle-icon{
                        float: left;
                        cursor: pointer;
                        margin-top: 36px;
                        width: 13px;
                        height: 13px;
                        background-image: url('./images/down.png');
                        background-size: 13px 13px;
                        background-repeat: no-repeat;

                    }
                    .toggle-icon{
                        float: left;
                        cursor: pointer;
                        margin-top: 38px;
                        width: 13px;
                        height: 13px;
                        background-image: url('./images/down.png');
                        background-size: 13px 13px;
                        transition: all 0.5s ease 0s;
                        &.reverse {
                            transform: rotate(180deg);
                        }

                    }
                    .user-img{
                        width:36px;
                        height:36px;
                        border-radius:100%;
                        margin-left: 15px;
                        margin-top:20px;
                        cursor:pointer;
                    }
                    .user-operate{
                        z-index: 100;
                        position: absolute;
                        left: 0px;
                        right: 0px;
                        top: 71px;
                        margin-left: 47px;
                        background-color: #fff;
                        padding: 24px 34px 20px 30px;
                        box-shadow: 0 1px 3px 0 rgba(0,0,0,0.08);
                        li {
                            clear: both;
                            font-size: 16px;
                            color: rgba(51,51,51,0.90);
                            letter-spacing: 0.11px;
                            cursor: pointer;
                            &:hover{
                                // color: #364983;
                            }
                            &:last-child{
                                margin-top: 19px;
                            }
                            .user-icon{
                                width: 21px;
                                height: 21px;
                                margin-top: 1px;
                                float: left;
                            }
                            .logout-icon{
                                width: 16px;
                                height: 16px;
                                margin-left: 1px;
                                margin-top: 2px;
                                float: left;
                            }
                            .user-msg{
                                margin-left: 11px;
                            }
                            .logout-msg{
                                margin-left: 13px;
                            }

                        }
                    }

                }
                .user-content{
                    position: relative;
                    &:before{
                        position: absolute;
                        content: '';
                        top: 0px;
                        bottom: 0px;
                        left: 0px;
                        border-left: 2px solid rgba(255,255,255,0.16);
                    }
                    .noLogin{
                        display:inline-block;
                        float:right;
                        width:65px;
                        height:28px;
                        line-height:28px;
                        text-align:center;
                        cursor:pointer;
                        a{
                            display:block;
                            width:100%;
                            height:100%;
                            font-size: 14px;
                            color: rgba(255,255,255,0.60);
                            letter-spacing: 0.14px;
                            border: 1px solid rgba(255,255,255,0.60);
                            &:hover{
                                background-color: rgba(255,255,255,0.25);
                                color: #fff;
                            }
                        }
                        &.login{
                            margin-right: 20px;
                        }

                        &.logOut{
                            color:#fff;
                            width:45px;
                            height:16px;
                            text-align:right;
                            line-height:16px;
                            margin-top:26px;
                            color:#666666;
                            border-left:1px solid #fff;
                        }

                    }
                    .search-icon {
                        display: inline-block;
                        width: 28px;
                        height: 29px;
                        margin-right: 16px;
                        background-image: url('./images/search.png');
                        background-size: cover;
                        cursor:pointer;
                    }

                }

            }
        }
        .slide-fade-enter-active {
            transition: all .3s ease;
        }
        .slide-fade-leave-active {
            transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-enter, .slide-fade-leave-to {
            transform: translateY(-10px);
            opacity: 0;
        }
    }

</style>

<template>
	<div id="headerBig">
		<div id="headerSma">
            <div class="content">
                <span class="logo" v-on:click="toIndex">
                    <img :src="logoIcon" />
                </span>
                <p class="navs">
        			<span class="navSpan" v-for="(el,index) in nav" :class="navNum == index ? 'current': ''">
                        <a :href="el.url">{{el.name}}</a>
                    </span>
                </p>
            </div>
            <div class="search-box" v-if="isShow">
                <input type="text" class="search-inp" placeholder="请输入关键词" v-model="keyword">
                <span :class="keyword ? 'search-btn' : 'search-btn disabled'" @click="toSearchPage">搜索</span>
            </div>
            <div class="userBox" v-if="!userInfo.userId">
                <div class="user-content">
                    <span class="noLogin register" v-if="!userInfo.userId"><a :href="registerUrl">注册</a></span>
                    <span class="noLogin login" v-if="!userInfo.userId"><a :href="loginUrl">登录</a></span>
                    <span class="noLogin search-icon" @click="toggleSearchBox"></span>
                </div>
            </div>
            <div class="userBox" :class="userInfo.userId? 'isLogin' : ''" v-else>
                <span class="search-icon-login" @click="toggleSearchBox"></span>
                <span class="name" :title="userInfo.nickName" v-on:click="changeToggle">
                    {{userInfo.nickName}}
                </span>
                <span class="toggle-icon" :class="!isToggle ? '': 'reverse'" v-on:click="changeToggle"></span>
                <!-- <span class="un-toggle-icon" v-if="!isToggle" v-on:click="changeToggle"></span> -->

                <img class="user-img" :src="userInfo.userImg" alt="" v-on:click="toUindex">
                <transition name="slide-fade">
                    <div class="user-operate" v-if="isToggle" v-on:mouseleave="changeToggle">
                        <li v-on:click="toUindex">
                            <span class="user-icon"><img :src="userIcon" /></span>
                            <span class="user-msg">用户中心</span>
                        </li>
                        <li v-on:click="logout">
                            <span class="logout-icon"><img :src="logoutIcon" /></span>
                            <span class="logout-msg">退出登录</span>
                        </li>
                    </div>
                </transition>
            </div>
		</div>
	</div>
</template>

<script>
    import messageCenter from 'message.center';
    import UserIcon from './images/user.png';
    import LogoutIcon from './images/logout.png';
    import logoIcon from './images/logo.png';

    export default Vue.component('ui-header',{
    	data:function(){
    		return {
                userIcon: UserIcon,
                logoutIcon: LogoutIcon,
                logoIcon: logoIcon,
                isShow: false,
                keyword: '',
                searchUrl: window.PAGE_DATA.commonData.searchUrl
    		}
    	},
        mounted:function(){
            let _this = this;
            messageCenter.onUpdateUserInfo(function(user){
                _this.userInfo = user;
            });
        },
        props:{
            navNum:{
                type: Number,
                default: 0
            },
            userInfo:{
                type: Object,
                default:{}
            },
            nav:{
                type: Array,
                default:[]
            },
            userList:{
                type: Array,
                default: []
            },
            loginUrl:{
                type: String,
                default: ''
            },
            ucenterUrl:{
                type: String,
                default: ''
            },
            logoutUrl:{
                type: String,
                default: ''
            },
            homeUrl:{
                type: String,
                default: ''
            },
            isToggle: {
                type: Boolean,
                default: false
            },
            registerUrl:{
                type: String,
                default: ''
            }
        },
        methods:{
            showSelect:function(){
                // this.show = true;
            },
            hideSelect:function(){
                // this.show = false;
                this.isToggle = !this.isToggle;
            },
            logout:function(){
                window.location.href = this.logoutUrl;

            },
            toIndex:function(){
                // window.open("http://www.forex.com.cn/")
                window.location.href = this.homeUrl;

            },
            toUindex:function(){
                // window.open("http://ucenter.forex.com.cn/");
                window.location.href = this.ucenterUrl;

            },
            changeToggle: function(){
                this.isToggle = !this.isToggle;
            },
            toggleSearchBox: function() {
                this.isShow = !this.isShow;
            },
            toSearchPage: function() {
                if(this.keyword === ''){
                    return;
                }
                window.location.href = this.searchUrl + "?keyword=" + encodeURI(this.keyword);
            }
        }
    })

</script>



// WEBPACK FOOTER //
// src/components/common/header/header.vue